import { baseProjects } from "../data/projectsData";

export function normalizeProjectTargetUrl(url) {
  if (url == null) return "";
  const s = String(url).trim();
  if (!s) return "";
  return s.startsWith("/") ? s : `/${s}`;
}

/** Routes that share ordering with another project slug */
const PATH_ALIASES = {
  "/SILTMiddelkerke-preview": "/SILTMiddelkerke",
};

export function canonicalProjectPath(pathname, extraAliases = {}) {
  const merged = { ...PATH_ALIASES, ...extraAliases };
  return merged[pathname] ?? pathname;
}

/**
 * Prev/next neighbours in `baseProjects` order, or null when not on a listed project route.
 */
export function getAdjacentProjects(pathname, extraAliases = {}) {
  const key = canonicalProjectPath(pathname, extraAliases);
  const idx = baseProjects.findIndex(
    (p) => normalizeProjectTargetUrl(p.targetUrl) === key
  );
  if (idx < 0) return null;

  const n = baseProjects.length;
  const prev = baseProjects[(idx - 1 + n) % n];
  const next = baseProjects[(idx + 1) % n];

  return {
    prev: {
      title: prev.title,
      to: normalizeProjectTargetUrl(prev.targetUrl),
    },
    next: {
      title: next.title,
      to: normalizeProjectTargetUrl(next.targetUrl),
    },
  };
}
